import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,

};

export default function OnboardingResReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_ONBOARDINGRESIDENTSDATA_INIT_ACTION:      
    return {
      ...state,
      onboardingResList:[],  
      loading:true     
    };
    case actionTypes.FETCH_ONBOARDINGRESIDENTSDATA_SUCCESS_ACTION:      
      return {
        ...state,
        onboardingResList: action.payload.response_data.apts,       
        loading:false 
      };
      case actionTypes.FETCH_ONBOARDINGRESIDENTSDATA_FAIL_ACTION:        
      return {
        ...state,
        onboardingResList:[], 
        loading:false      
      };

     

    default:
      return {
        ...state,
      };
  }
}
